export default "__VITE_ASSET__VTePGdPq__"